import lazyload from "@/lazyload";
const $clamp = require('clamp');
const $preloader = document.querySelector('.loader-wrapper');

export default () => {
  function handleLoadMoreEvent(entries) {
    const [entry] = entries;
    if (entry.isIntersecting) {

      let loader = $('.loader-wrapper');
      let content = $('.news-onfrontpage');
      let endpoint = content.attr('data-href');

      if (endpoint !== "") {
        $.ajax({
          url: endpoint
        })
            .done(function (response) {
              content.append(response.html);
              lazyload.update();
              if (response.nextPage) {
                content.attr('data-href', response.nextPage);
              } else {
                loader.remove();
              }
            });
      } else {
        loader.remove();
      }
    }
  }

  let pathname = window.location.pathname;
  $('.morecontentfromtheauthor .news-onfrontpage .new-fronpage .new-info .new-title').each(function(){
    if ($(this).attr("href") === pathname) {
      $(this).closest(".new-fronpage").remove();
    }

    $clamp($(this).get(0), { clamp: '76px' });
  });

  $('.news-onfrontpage .new-fronpage .new-info .new-title').each(function(){
    $clamp($(this).get(0), { clamp: '76px' });
  });

  // Si el modulo con los contenidos de autor no tiene nada visible entonces lo ocultamos
  if ($(".morecontentfromtheauthor .news-onfrontpage .new-fronpage:not([hidden])").length === 0) {
    $(".morecontentfromtheauthor").attr("hidden", true);
  }

  if ($preloader != null) {
    // Carga automatica de contenidos
    const observer = new IntersectionObserver(handleLoadMoreEvent, {
      rootMargin: '100px 0px'
    });

    observer.observe($preloader);
  }
}
